export interface Group {
  id: string;
  name: string;
  path: string;
}
export interface Account {
  id: string;
  firstName: string;
  lastName: string;
  position: string;
  role: string;
  email: string;
  status: AccountStatus;
  avatarUrl?: string;
  initials: string;
  createdAt: Date;
  updatedAt: Date;
  permissions?: string[];
  groups: Group[];
  isCurrentUser: boolean;
}

export enum AccountStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}
export interface ActivityLogEntry {
  items: ActivityLogItem[];
  totalCount: number;
}

export interface ActivityLogItem {
  id: string;
  activityType: string;
  entityNameValue: string;
  date: Date;
}

export interface CreateAccountDto {
  firstName: string;
  lastName: string;
  position: string;
  email: string;
  groups: string[];
  profileFile?: File;
}

export interface CreateAccountResponse {
  userId: string;
  email: string;
}

export interface UpdateAccountDto {
  firstName?: string;
  lastName?: string;
  position?: string;
  groups?: string[];
  profileFile?: File;
}

export interface AccountFilters {
  search?: string;
  status?: AccountStatus;
  role?: number;
  sortBy?: AccountSortField;
  sortOrder?: 'asc' | 'desc';
}

export enum AccountSortField {
  NAME_ASC = 'name_asc',
  NAME_DESC = 'name_desc',
  CREATED_DATE = 'created_date',
  UPDATED_DATE = 'updated_date',
}

export interface PagedResult<T> {
  items: T[];
  totalCount: number;
  pageIndex: number;
  totalPages: number;
}
